"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import Link from "next/link";

/**
 * 全站提醒：你擔任負責人的部門還有任務要勾、要指派或要送審
 * （2026-10-07 取代 PendingHelpersBanner · 幫手功能移除）
 */
export default function PendingDeptBanner() {
  const [count, setCount] = useState(0);
  const pathname = usePathname();

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const r = await fetch("/api/my/pending-depts", {
          credentials: "include",
          cache: "no-store",
        });
        if (!r.ok) return;
        const j = await r.json();
        if (mounted) setCount(Number(j.count ?? 0));
      } catch { /* noop */ }
    };
    load();
    // 每 60 秒重撈 · 送審完 banner 自動消失
    const t = setInterval(load, 60_000);
    return () => { mounted = false; clearInterval(t); };
  }, [pathname]);

  // 已經在待處理頁上就不重複提醒
  if (count === 0 || pathname?.startsWith("/my/dept-setup")) return null;

  return (
    <div style={{
      background: "#FEF3C7",
      color: "#78350F",
      border: "1.5px solid #F59E0B",
      borderRadius: 8,
      padding: "10px 14px",
      margin: "0 0 12px 0",
      display: "flex",
      alignItems: "center",
      gap: 10,
      fontSize: 13,
    }}>
      <span style={{ fontSize: 18 }}>⭐</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <strong style={{ fontSize: 13 }}>你負責的 {count} 個部門待送審</strong>
        <div style={{ fontSize: 12, marginTop: 2, opacity: 0.9 }}>
          勾任務、指派、設定金額後送審 · PM 才能接著審核。
        </div>
      </div>
      <Link
        href="/my/dept-setup"
        style={{
          background: "#D97706",
          color: "#fff",
          padding: "6px 14px",
          borderRadius: 6,
          fontSize: 12,
          fontWeight: 700,
          textDecoration: "none",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        去處理 →
      </Link>
    </div>
  );
}
